import Success from "~/components/Icons/Notifications/Success";
import Error from "~/components/Icons/Notifications/Error";
import Warning from "~/components/Icons/Warning";
import React from "react";
import s from "../CameraZonesView.less";
import { CameraCheckStatus, CameraStatus } from "~/schemas/generated/graphql";

interface IStatusResolver {
  status: CameraCheckStatus | CameraStatus;
}

const StatusResolver = ({ status }: IStatusResolver) => {
  const resolveStatus = (status: CameraCheckStatus | CameraStatus) => {
    switch (status) {
      case CameraStatus.Compliant:
      case CameraCheckStatus.Compliant:
        return <Success />;
      case CameraStatus.NotCompliant:
      case CameraCheckStatus.NotCompliant:
        return <Error />;
      case CameraStatus.NotVerified:
      case CameraCheckStatus.NotVerified:
        return <Warning />;
    }
  };

  return <div className={s.status}>{resolveStatus(status)}</div>;
};

export default StatusResolver;
